export const READ_ONLY_ACTION_MESSAGE =
	"You have read-only access. This action is disabled.";
